/**
 * Env wrapper around Date.now()
 * @module
 */

/**
 * @returns {number}
 *       Integer number of milliseconds elapsed since 1 January 1970 00:00:00 UTC.
 */
exports.now = function(): number {
  return +new Date();
};
